import { useState } from "react";
import MDTypography from "components/MDTypography";
import { IconButton, Tooltip } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import DoNotDisturbAltOutlinedIcon from "@mui/icons-material/DoNotDisturbAltOutlined";
import CTLNotification from "application/components/CTLNotification";
import variables from "globals/variables";
import axios from "axios";

function DownloadFile({ row }) {
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
    pagename: "",
    status: "",
  });

  const filename = row?.original?.path ?? null;
  const extractedFilename = filename?.includes("/")
    ? filename.substring(filename.lastIndexOf("/") + 1)
    : filename;

  const downloadURL = filename
    ? `${variables?.app?.services ?? ""}auth/downloadMp3?path=${encodeURIComponent(filename)}`
    : null;

  const onDownloadFile = async () => {
    if (!filename || !downloadURL) {
      setNotify({
        isOpen: true,
        status: "Unable To Download File: File Not Exist",
        type: "error",
        pagename: "voice picker",
      });
      return;
    }

    try {
      const response = await axios.get(downloadURL, { responseType: "blob" });

      if (response.status === 200) {
        const blobData = new Blob([response.data]);
        const url = window.URL.createObjectURL(blobData);
        const link = document.createElement("a");
        link.href = url;
        link.download = extractedFilename || "recording.mp3";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        setNotify({
          pagename: "Conference Recording",
          isOpen: true,
          status: "MP3 File Download Successful",
          type: "success",
        });
      } else {
        throw new Error(`Download failed with status: ${response.status}`);
      }
    } catch (error) {
      console.error("Download Error:", error);
      setNotify({
        isOpen: true,
        message: "Unable To Download File",
        type: "error",
        pagename: "voice picker",
        status: error.response?.status ?? "Unknown Error",
      });
    }
  };

  return (
    <MDTypography variant="caption" fontWeight="medium" color="text">
      <Tooltip title={filename ? "Download File" : "File Not Exist"}>
        <IconButton
          color={filename ? "primary" : "error"}
          onClick={onDownloadFile}
        >
          {filename ? <DownloadIcon /> : <DoNotDisturbAltOutlinedIcon />}
        </IconButton>
      </Tooltip>

      <CTLNotification notify={notify} setNotify={setNotify} />
    </MDTypography>
  );
}

export default DownloadFile;
